import React, { Component } from 'react';
import { FormattedMessage, injectIntl, intlShape, defineMessages } from 'react-intl';
import TextField from 'react-md/lib/TextFields';
import Recaptcha from 'react-google-recaptcha';

import './ContactForm.css';

const RECAPTCHA_KEY = '6Le9TlwUAAAAANmO2Rf-jvcn8xZ2OLCsvN27evxG';

const encode = (data) => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
}

class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subject: 'Gaijin ' + (this.props.intl.locale ==="fi"?'tiedustelu':'contact request'),
	  language: this.props.intl.locale,
      name: '',
      email: '',
      phone: '',
      message: '',
      success: false,
      error: false,
    };
  }

  handleChange(field, value) {
    this.setState({
      [field]: value
    });
  }
  
  handleRecaptcha(value) {
    this.setState({ "g-recaptcha-response": value });
  };

  handleSubmit(e) {
    e.preventDefault();

    if(this.state.email && this.state.message) {
      fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: encode({ "form-name": "contact", ...this.state })
      })
      .then(() => this.setState({ success: true, error: false }))
      .catch(error => this.setState({ success: false, error: true }))
    }
    else {
      this.setState({ error: true })
    }
  }

  render() {
    const labels = defineMessages({
      name: { id: 'contactForm.name' },
      email: { id: 'contactForm.email' },
      phone: { id: 'contactForm.phone' },
      message: { id: 'contactForm.message' },
      submit: { id: 'contactForm.submit' },
    });

    return (
      <div>
        <h2><FormattedMessage id="contactForm.heading" /></h2>
        { !this.state.success &&
          <form name="contact" onSubmit={this.handleSubmit.bind(this)} data-netlify-recaptcha="true">
            <input type="hidden" name="bot-field" value="" />
            <p><FormattedMessage id="contactForm.description" /></p>
            <fieldset>
              <TextField id="name" className="md-cell"
                label={this.props.intl.formatMessage(labels.name)}
                onChange={(e) => this.handleChange('name', e)} value={this.state.name} />
              <TextField id="email" type="email" className="md-cell" required
                label={this.props.intl.formatMessage(labels.email)}
                onChange={(e) => this.handleChange('email', e)} value={this.state.email} />
              <TextField id="phone" className="md-cell"
                label={this.props.intl.formatMessage(labels.phone)}
                onChange={(e) => this.handleChange('phone', e)} value={this.state.phone} />
              <TextField id="message" className="md-cell" rows={3} required
                label={this.props.intl.formatMessage(labels.message)}
                onChange={(e) => this.handleChange('message', e)} value={this.state.message} />
              <br/>
              <Recaptcha
                ref="recaptcha"
                sitekey={RECAPTCHA_KEY}
                onChange={(val) => this.handleRecaptcha(val)}
                theme="dark"
              />
              <br/>            
              <button disabled={!this.state['g-recaptcha-response']} type="submit">{this.props.intl.formatMessage(labels.submit)}</button>
            </fieldset>
          </form>
        }
        { !this.state.success && this.state.error &&
          <p className="fail">
            <FormattedMessage id="contactForm.fail" />
          </p>
        }
        {
          this.state.success &&
          <p className="success">
            <FormattedMessage id="contactForm.success" />
          </p>
        }
      </div>
    )
  }
}

ContactForm.propTypes = {
  intl: intlShape.isRequired,
}

export default injectIntl(ContactForm)



// WEBPACK FOOTER //
// ./src/components/ContactForm.js